<template>
    <iframe :src="value" width="100%" height="720px" frameBorder="0"></iframe>
</template>

<script>
export default {
    name: 'gpt-chart-page',
    props: {
        value: {
            type: String
        }
    }
};
</script>
<style scoped lang="scss">
</style>
